import { gql } from '@apollo/client';
import { TRANSLATED_STRING_FIELDS } from '@assets/i18n/config';

export const FETCH_CLIENT_REPORT_NAME = gql`
  query fetchClientReportTemplate($clientReportTemplateId: ObjectID!) {
    fetchClientReportTemplate(clientReportTemplateId: $clientReportTemplateId) {
      clientReportTemplate {
        translatedName { ${TRANSLATED_STRING_FIELDS} }
      }
    }
  }
`;
